import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const ArrowUp = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M11.9999 22.2029c-.3192 0-.5886-.1098-.8083-.3293-.2195-.2197-.3292-.4891-.3292-.8082V6.1474L7.1836 9.807c-.2113.2153-.4734.3262-.7862.3325-.3128.0063-.5812-.1045-.805-.3325-.2113-.2112-.317-.4763-.317-.7955s.1057-.5844.317-.7957l5.6117-5.612c.112-.1119.2354-.1926.37-.2423a1.2195 1.2195 0 01.4258-.0745c.1493 0 .2922.0248.4287.0745.1367.0497.261.1304.373.2423l5.6118 5.612c.2113.2113.318.4724.32.7832.002.3108-.1047.5802-.32.808-.2278.228-.4972.342-.808.342-.3108 0-.5803-.114-.8083-.342l-3.6597-3.6597v14.918c0 .3191-.1098.5885-.3293.8082-.2196.2195-.489.3293-.8082.3293z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M11.9999 22.2029c-.3192 0-.5886-.1098-.8083-.3293-.2195-.2197-.3292-.4891-.3292-.8082V6.1474L7.1836 9.807c-.2113.2153-.4734.3262-.7862.3325-.3128.0063-.5812-.1045-.805-.3325-.2113-.2112-.317-.4763-.317-.7955s.1057-.5844.317-.7957l5.6117-5.612c.112-.1119.2354-.1926.37-.2423a1.2195 1.2195 0 01.4258-.0745c.1493 0 .2922.0248.4287.0745.1367.0497.261.1304.373.2423l5.6118 5.612c.2113.2113.318.4724.32.7832.002.3108-.1047.5802-.32.808-.2278.228-.4972.342-.808.342-.3108 0-.5803-.114-.8083-.342l-3.6597-3.6597v14.918c0 .3191-.1098.5885-.3293.8082-.2196.2195-.489.3293-.8082.3293z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M11.9999 22.2029c-.3192 0-.5886-.1098-.8083-.3293-.2195-.2197-.3292-.4891-.3292-.8082V6.1474L7.1836 9.807c-.2113.2153-.4734.3262-.7862.3325-.3128.0063-.5812-.1045-.805-.3325-.2113-.2112-.317-.4763-.317-.7955s.1057-.5844.317-.7957l5.6117-5.612c.112-.1119.2354-.1926.37-.2423a1.2195 1.2195 0 01.4258-.0745c.1493 0 .2922.0248.4287.0745.1367.0497.261.1304.373.2423l5.6118 5.612c.2113.2113.318.4724.32.7832.002.3108-.1047.5802-.32.808-.2278.228-.4972.342-.808.342-.3108 0-.5803-.114-.8083-.342l-3.6597-3.6597v14.918c0 .3191-.1098.5885-.3293.8082-.2196.2195-.489.3293-.8082.3293z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
ArrowUp.displayName = "ArrowUpIcon";

export { ArrowUp, ArrowUp as default };
